require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./data-visualization-data-visualization-projects-visualize-data-with-a-bar-chart.json") })
        }
      }, "path---data-visualization-data-visualization-projects-visualize-data-with-a-bar-chart");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---data-visualization-data-visualization-projects-visualize-data-with-a-bar-chart!./.cache/json/data-visualization-data-visualization-projects-visualize-data-with-a-bar-chart.json
// module id = 1948
// module chunks = 231608221292675